export const backgroundDark = '#212128';

const palleteDark = colors => ({
  // default material-ui pallete use:
  type: 'dark',
  primary: {
    main: colors.primary,
  },
  secondary: {
    main: '#FFFFFF',
  },
  error: {
    main: colors.negative,
  },
  text: {
    primary: 'rgba(255,255,255, 1)',
    secondary: 'rgba(255,255,255, .92)',
    hint: 'rgba(255,255,255, .72)',
    disabled: 'rgba(255,255,255, .38)',
  },
  background: {
    default: '#2B2B33',
    paper: backgroundDark,
  },
  // custom user pallete for components:
  custom: {
    background: {
      app: '#2B2B33',
      area: backgroundDark,
    },
    surface: [
      'rgba(255,255,255, .03)',
      'rgba(255,255,255, .06)',
      'rgba(255,255,255, .08)',
      'rgba(255,255,255, .12)',
      'rgba(255,255,255, .16)',
    ],
    feedback: {
      positive: colors.positive,
      negative: colors.negative,
      warning: colors.warning,
    },
  },
});

export default palleteDark;
